export default function filter(value, data) {
    const { list, indexedCategories, indexedParents } = data
    const usedItems = {}
    let filteredParents = {}
    let filterd = []
    const expandedCats = []

    // Check input type and count
    if ((parseInt(value) && typeof parseInt(value) === 'number') || value.length > 2) {
        // Loop over original list items array
        list.forEach(async item => {
            const newItem = { ...item, selected: false }
            if (newItem.name.includes(value) || newItem.id.toString() === value) {
                newItem.selected = true
                // Check if the item is a parent and add it to the filtered parents array
                if (indexedParents[newItem.id] && !filteredParents[newItem.id]) {
                    filteredParents[newItem.id] = []
                    indexedParents[newItem.id].forEach(child => {
                        const newChild = {
                            ...child,
                            selected: child.name.includes(value) || child.id.toString() === value
                        }
                        if (!usedItems[child.id]) {
                            filteredParents[newItem.id] = [...filteredParents[newItem.id], newChild]
                            usedItems[child.id] = true
                        }
                    })
                    filterd.push(newItem)
                    usedItems[newItem.id] = true
                    // expandedCats.push(newItem.id.toString())
                }

                // Check if the item has parents and add them to the filtered parents array
                if (newItem.parent_id) {
                    if (!usedItems[newItem.parent_id]) {
                        usedItems[newItem.parent_id] = true
                        const newParent = {
                            ...indexedCategories[newItem.parent_id],
                            selected:
                                indexedCategories[newItem.parent_id].name.includes(value) ||
                                indexedCategories[newItem.parent_id].id.toString() === value
                        }
                        filterd.push(newParent)
                        expandedCats.push(newItem.parent_id.toString())
                    }
                    if (!usedItems[newItem.id]) {
                        filteredParents[newItem.parent_id] = filteredParents[newItem.parent_id]
                            ? [newItem, ...filteredParents[newItem.parent_id]]
                            : [newItem]
                        usedItems[newItem.id] = true
                    }
                } else if (!usedItems[newItem.id]) {
                    filterd.push(newItem)
                    usedItems[newItem.id] = true
                }
            }
        })
    } else {
        filterd = [...list]
        filteredParents = { ...indexedParents }
    }

    return { filterd, filteredParents, expandedCats }
}
